module.exports = __webpack_public_path__ + "img/target-and-arrow-svgrepo-com.45bc1f12.svg";